{
  "nav": {
    "chat": "Sitzung",
    "agents": "Agents",
    "history": "Verlauf",
    "files": "Dateien",
    "changes": "Änderungen",
    "mailbox": "Postfach",
    "skills": "Skills",
    "worktrees": "Worktrees",
    "design": "Design Studio",
    "officemap": "Bürokarte",
    "settings": "Einstellungen",
    "sddwizard": "Neues SDD-Projekt",
    "specs": "Spezifikationen",
    "sddboard": "Live-Board",
    "autophase": "Phasen",
    "fleet": "Fleet",
    "inspector": "Inspektor",
    "prompts": "Prompts"
  },
  "brand": {
    "returnToChat": "{{name}} — zurück zum Chat",
    "returnToChatDefault": "WrongStack — zurück zum Chat"
  },
  "status": {
    "connected": "Verbunden",
    "disconnected": "Getrennt",
    "idle": "Inaktiv",
    "thinking": "Denkt nach",
    "running": "Läuft",
    "waiting": "Wartend",
    "done": "Fertig",
    "stopped": "Gestoppt"
  },
  "menu": {
    "moreWithHidden": "Mehr, {{count}} ausgeblendete Elemente",
    "moreOptions": "Weitere Optionen",
    "moreCompactHidden": "Mehr — {{count}} ausgeblendete Panels/Ansichten, Palette, Design, Monitore",
    "moreCompact": "Mehr — Palette, Design, Monitore",
    "moreFull": "Mehr — Palette, Design, Tastenkürzel, Monitore",
    "commandPalette": "Befehls-Palette",
    "keyboardShortcuts": "Tastenkürzel",
    "panels": "Panels",
    "views": "Ansichten",
    "theme": "Design",
    "monitors": "Monitore",
    "fleetMonitor": "Fleet-Monitor",
    "agentsMonitor": "Agents-Monitor"
  },
  "sidePanel": {
    "dragHint": "Ziehen zum Skalieren · Doppelklick zum Zurücksetzen",
    "collapse": "Panel einklappen (Ctrl+\\)"
  },
  "history": {
    "openDashboard": "Sitzungs-Dashboard öffnen"
  },
  "agents": {
    "pending": "ausstehend…",
    "empty": "Noch keine Agents",
    "emptyHint": "Subagents erscheinen hier, wenn die Fleet aktiv ist.",
    "runningCount": "{{count}} läuft",
    "totalCount": "{{count}} gesamt",
    "openFull": "Vollständige Agents-Ansicht öffnen",
    "agentsLive": "AGENTS · LIVE",
    "doneCount": "{{count}} fertig",
    "failedCount": "{{count}} fehlgeschlagen",
    "modelsLabel": "Modelle",
    "shownLabel": "angezeigt",
    "totalLabel": "gesamt",
    "leaderFleetTotals": "(Leader {{leader}} · Fleet {{fleet}})",
    "navHintJk": "j/k oder ↑↓ zum Navigieren",
    "escCloseDetail": "· Esc um Detail zu schließen",
    "noAgentsRunning": "Keine Agents aktiv.",
    "contextUsage": "Kontext-Nutzung",
    "lastToolLabel": "zuletzt:",
    "unknownSession": "Unbekannte Session",
    "sessionCopyTitle": "Session: {{sid}} — klicken zum Kopieren",
    "sessionWord": "Session",
    "agentsCountSuffix_one": "{{count}} Agent",
    "agentsCountSuffix_other": "{{count}} Agents",
    "sessionTitle": "Session: {{sid}}",
    "projectSuffix": " · Projekt: {{name}}",
    "statusIdle": "idle"
  },
  "changes": {
    "fileCount_one": "{{count}} Datei",
    "fileCount_other": "{{count}} Dateien",
    "refreshTitle": "Änderungen aktualisieren",
    "loading": "Änderungen werden geladen…",
    "clean": "Keine Änderungen — Arbeitsbaum ist sauber.",
    "selectPrompt": "Wähle eine geänderte Datei, um den Diff anzuzeigen.",
    "unified": "Vereinigt",
    "unifiedTitle": "Vereinigter Diff",
    "edit": "Bearbeiten",
    "editTitle": "Side-by-side bearbeitbarer Diff",
    "loadingDiff": "Diff wird geladen…",
    "binary": "Binärdatei — Diff nicht angezeigt.",
    "tooLarge": "Datei zu groß für Diff."
  },
  "inspector": {
    "showPanel": "Inspektor-Panel anzeigen (Fleet / Agents / Audit)",
    "hidePanel": "Inspektor-Panel ausblenden",
    "label": "Inspektor",
    "openAudit": "Audit-Tab öffnen",
    "tabFleet": "Fleet",
    "tabAgents": "Agents",
    "tabAudit": "Audit",
    "collapseAria": "Inspektor-Panel einklappen",
    "collapseTitle": "Einklappen (Esc)",
    "noAgentsActive": "Keine Agents aktiv",
    "agentsAppearHint": "Agents erscheinen hier, wenn die Fleet aktiv ist.",
    "selected": "{{name}} (ausgewählt)"
  },
  "nextSteps": {
    "header": "Nächste Schritte",
    "autoSubmitting": "automatisches Senden in",
    "clickToFill": "Klicken zum Ausfüllen",
    "clickToFillTitle": "Klicken zum Ausfüllen: {{text}}",
    "auto": "auto",
    "willAutoSubmit": "Wird nach Countdown automatisch gesendet"
  },
  "mailbox": {
    "onlineCount": "{{count}} online",
    "messages": "Nachrichten",
    "deleteAllTitle": "Alle Nachrichten löschen",
    "deleteAll": "Alle löschen",
    "deleting": "Wird gelöscht…",
    "purgeTitle": "Veraltete/verwaiste Nachrichten bereinigen",
    "purge": "Bereinigen",
    "purging": "Wird bereinigt…",
    "newLabel": "NEU",
    "empty": "Noch keine Nachrichten.",
    "offlineCount": "+{{count}} offline",
    "timeNow": "jetzt",
    "deleteAllConfirmTitle_one": "{{count}} Nachricht löschen?",
    "deleteAllConfirmTitle_other": "Alle {{count}} Nachrichten löschen?",
    "deleteAllConfirmBody": "Die Mailbox-Datei wird für jeden Agent abgeschnitten. Dies kann nicht rückgängig gemacht werden.",
    "purgeConfirmTitle": "Veraltete Nachrichten bereinigen?",
    "purgeConfirmBody": "Entfernt abgeschlossene Nachrichten älter als 1 Tag und unvollständige Nachrichten älter als 7 Tage. Aktive Nachrichten bleiben erhalten.",
    "type": {
      "note": "Notiz",
      "ask": "Frage",
      "assign": "Zuweisung",
      "steer": "Lenken",
      "btw": "Nebenbei",
      "broadcast": "Rundruf",
      "status": "Status",
      "result": "Ergebnis"
    },
    "emptyDetail": "Keine Nachricht ausgewählt",
    "emptyDetailHint": "Klicke im Mailbox-Panel auf eine Nachricht, um sie hier anzuzeigen.",
    "readBy": "Gelesen von",
    "backToChat": "Zurück zum Chat",
    "completed": "Erledigt",
    "everyone": "alle",
    "closeTitle": "Schließen (Esc)",
    "replyTo": "Antwort auf: {{id}}",
    "completedBy": "Von {{name}} erledigt",
    "completedByAt": "Von {{name}} am {{time}} erledigt",
    "outcome": "Ergebnis:",
    "task": "Aufgabe:",
    "messageNotFound": "Nachricht nicht gefunden",
    "messageNotFoundHint": "Diese Nachricht wurde möglicherweise gelöscht oder bereinigt."
  },
  "sessions": {
    "recentSessions": "Letzte Sitzungen",
    "deleteEmptyTitle_one": "{{count}} leere Sitzung löschen?",
    "deleteEmptyTitle_other": "{{count}} leere Sitzungen löschen?",
    "deleteEmptyConfirmBody": "Sitzungen ohne Token-Nutzung werden von der Festplatte entfernt.",
    "filterPlaceholder": "Titel, Modell, Anbieter filtern…",
    "clearFilter": "Filter löschen",
    "noHistory": "Noch kein Verlauf",
    "noHistoryHint": "Deine Konversationen erscheinen hier",
    "noMatches": "Keine Treffer",
    "noMatchesHint": "Versuche einen anderen Filter",
    "group": {
      "favorites": "Favoriten",
      "today": "Heute",
      "yesterday": "Gestern",
      "thisWeek": "Diese Woche",
      "earlier": "Früher"
    },
    "nicknamePlaceholder": "Spitzname",
    "empty": "(leer)",
    "resuming": "wird fortgesetzt…",
    "active": "aktiv",
    "renameTitleNickname": "{{nickname}} — original: {{title}}",
    "renameTitle": "{{title}}\n\nDoppelklick zum Umbenennen",
    "unfavorite": "Aus Favoriten entfernen",
    "markFavorite": "Als Favorit markieren",
    "deleteSessionConfirmTitle": "Sitzung löschen?",
    "deleteSessionConfirmBody": "\"{{name}}\" wird von der Festplatte entfernt. Dies kann nicht rückgängig gemacht werden.",
    "deleteSessionTitle": "Sitzung löschen"
  },
  "sessionPanel": {
    "actions": {
      "abort": "Abbrechen",
      "newSession": "Neue Sitzung",
      "export": "Export",
      "compact": "Komprimieren",
      "newSessionTitle": "Neue Sitzung starten (Ctrl+N)",
      "exportTitle": "Chat als Markdown exportieren (Ctrl+E)",
      "compactTitle": "Kontextfenster komprimieren",
      "clearTitle": "Kontext löschen (Ctrl+L)"
    },
    "model": "Modell",
    "modelTitle": "Modell ändern (Ctrl+M)",
    "context": "Kontext",
    "contextTitle": "Klicken für eine Kontextaufschlüsselung",
    "sessionLabel": "Sitzung",
    "stats": {
      "messages": "Nachrichten",
      "elapsed": "Verstrichen",
      "tokens": "Tokens",
      "cost": "Kosten",
      "iteration": "Iteration",
      "agents": "Agents",
      "tokensSub": "{{in}} rein / {{out}} raus",
      "iterationOf": "von {{max}}",
      "agentsRunning": "{{count}} läuft"
    },
    "plan": "Plan",
    "planComplete": "{{pct}}% fertig",
    "pinned": "Angeheftet",
    "quickSettings": "Schnelleinstellungen",
    "autonomy": "Autonomie",
    "autonomyOptions": {
      "off": "Aus",
      "suggest": "Vorschlagen",
      "auto": "Auto",
      "eternal": "Endlos",
      "eternal-parallel": "Endlos Parallel"
    },
    "yolo": "YOLO-Modus",
    "yoloTitle": "Tool-Bestätigungsdialoge überspringen",
    "refine": "Prompts verfeinern",
    "refineTitle": "Prompts vor dem Senden umschreiben",
    "sound": "Ton bei Fertigstellung",
    "soundTitle": "Sanften Gong abspielen, wenn ein Lauf endet",
    "sessionId": "Sitzung {{id}}"
  },
  "fleet": {
    "status": {
      "running": "läuft",
      "done": "fertig",
      "failed": "fehlgeschlagen",
      "timeout": "Zeitüberschreitung",
      "stopped": "gestoppt"
    },
    "leader": "Leader",
    "providerModel": "Anbieter / Modell",
    "elapsed": "Verstrichen",
    "running": "läuft…",
    "iterations": "Iterationen",
    "toolCalls": "Tool-Aufrufe",
    "cost": "Kosten",
    "budgetExtensions": "Budget-Erweiterungen",
    "activity": "Aktivität",
    "budgetWarning": "Budget-Warnung",
    "contextWindow": "Kontextfenster",
    "tokensUsed": "{{used}} / {{max}} Tokens",
    "toolRunning": "läuft…",
    "lastTool": "letztes Tool",
    "error": "Fehler",
    "finalOutput": "Endgültige Ausgabe",
    "copyOutput": "Ausgabe kopieren",
    "liveOutput": "Live-Ausgabe",
    "waitingOutput": "Warte auf Ausgabe…",
    "outputHint": "Die Ausgabe erscheint hier, sobald der Agent Text streamt.",
    "toolLog": "Tool-Log ({{count}} Aufrufe)",
    "fail": "Fehlschlag",
    "moreTools": "+{{count}} weitere Tools",
    "cardRunning": "läuft {{tool}}",
    "cardLastTool": "zuletzt: {{tool}}",
    "contextPercent": "Kontext {{pct}}%",
    "doneCount": "{{count}} fertig",
    "errCount": "{{count}} Fehler",
    "statusRunning": "läuft",
    "statusDone": "fertig",
    "statusFailed": "fehlgeschlagen",
    "statusTimeout": "Timeout",
    "statusStopped": "gestoppt",
    "sessionPrefix": "Session:",
    "currentTask": "Aktuelle Task",
    "performance": "Performance",
    "uniqueTools": "Eindeutige Tools",
    "avgPerTool": "ø {{ms}}ms pro Tool",
    "context": "Kontext",
    "tokens": "Token",
    "ctxUsed": "{{pct}}% genutzt",
    "completed": "abgeschlossen",
    "budgetWarningTitle": "⚡ Budget-Warnung",
    "hittingLimit": "Erreicht {{kind}}-Limit ({{used}}/{{limit}})",
    "hittingLimitTitle": "⚡ erreicht {{kind}}-Limit ({{used}}/{{limit}})",
    "budgetExt_one": "{{count}} Budget-Erweiterung",
    "budgetExt_other": "{{count}} Budget-Erweiterungen",
    "extendedTimes_one": "Agent hat sein Budget {{count}}-mal wegen langer Tasks erweitert",
    "extendedTimes_other": "Agent hat sein Budget {{count}}-mal wegen langer Tasks erweitert",
    "errorLabel": "Fehler",
    "failureReason": "Fehlergrund",
    "failed": "Fehlgeschlagen",
    "fleetMonitor": "FLEET-MONITOR",
    "runningCount": "{{count}} läuft",
    "totalAgents_one": "{{count}} Agent gesamt",
    "totalAgents_other": "{{count}} Agents gesamt",
    "noLeader": "kein Leader",
    "closeFleet": "Fleet-Monitor schließen",
    "colName": "Name",
    "colStatus": "Status",
    "colActivity": "Aktivität",
    "colIters": "Iter.",
    "colTools": "Tools",
    "colCost": "Kosten",
    "colCtx": "CTX",
    "colExt": "Erw.",
    "colReason": "Grund",
    "noAgentsActive": "Keine Agents aktiv",
    "agentsAppear": "Agents erscheinen hier, wenn die Fleet aktiv ist.",
    "agentTimeline": "Agent-Zeitleiste",
    "noAgentEvents": "Noch keine Agent-Konversationsereignisse.",
    "navHint": "↑↓ navigieren",
    "selectDetailHint": "↵ Detail wählen",
    "escHint": "Esc Auswahl aufheben / schließen",
    "detailedView": "Detailansicht",
    "closeBtn": "✕ schließen",
    "selectAgentDetail": "Wähle einen Agent für detaillierte Informationen",
    "selectAgentBody": "Klicke einen Agent in der Liste für detaillierte Metriken, Tool-Logs, Streaming-Ausgabe und mehr — ähnlich der Chat-Verlauf-Detailansicht.",
    "navigateWord": "navigieren",
    "selectWord": "wählen",
    "deselectWord": "aufheben"
  },
  "context": {
    "wsNotConnected": "WebSocket nicht verbunden",
    "noData": "Keine Debug-Daten empfangen. Der Server unterstützt möglicherweise kein Context-Debugging.",
    "title": "Kontext-Aufschlüsselung",
    "windowUsage": "Fensterauslastung",
    "contextMode": "Kontextmodus",
    "fetching": "Kontext-Aufschlüsselung wird geladen…",
    "systemPrompt": "System-Prompt",
    "tools": "Tools",
    "messages": "Nachrichten",
    "tokenAllocation": "Token-Verteilung",
    "systemTitle": "System: {{tokens}}",
    "toolsTitle": "Tools: {{tokens}}",
    "messagesTitle": "Nachrichten: {{tokens}}",
    "system": "System",
    "toolBreakdown": "Tool-Aufschlüsselung",
    "messagesSummary": "Nachrichten ({{count}}) — {{total}} Tok",
    "barWithTokens": "Kontextfenster: {{tokens}} / {{max}} Token ({{pct}})",
    "barPct": "Kontextfenster: {{pct}}",
    "barClick": " — für Aufschlüsselung klicken"
  },
  "refine": {
    "header": "✨ Prompt verfeinern",
    "autoSend": "Auto-Send in {{count}} s",
    "cancelTitle": "Abbrechen (Esc)",
    "editLabel": "Verfeinerten Prompt bearbeiten:",
    "editPlaceholder": "Verfeinerten Prompt bearbeiten ...",
    "useEdit": "Bearbeitung verwenden",
    "original": "Original",
    "refined": "Verfeinert",
    "yourLanguage": "(deine Sprache)",
    "refinedTitle": "Klicken oder Enter drücken, um diese Version zu verwenden",
    "english": "Englisch",
    "englishTitle": "e drücken, um die englische Version zu verwenden",
    "hintRefined": "verfeinert",
    "hintEnglish": "Englisch",
    "hintOriginal": "original",
    "hintEdit": "bearbeiten",
    "edit": "Bearbeiten",
    "useRefined": "Verfeinerte verwenden"
  },
  "specs": {
    "heading": "Spezifikationen",
    "subtitle": "Spezifikationsgetriebene Entwicklung anzeigen und verwalten",
    "empty": "Keine Specs gefunden. Mit {{command}} eine erstellen.",
    "tasks": "Aufgaben ({{count}})",
    "doneCount": "{{count}} erledigt",
    "runningCount": "{{count}} läuft",
    "pendingCount": "{{count}} ausstehend",
    "runTitle": "Dieses Spec als Live-AutoPhase-Board ausführen",
    "run": "Ausführen",
    "list": "Liste",
    "graph": "Graph",
    "loadingTasks": "Aufgaben werden geladen…"
  },
  "refresh": {
    "heading": "F5-Resilienz-Prüfer",
    "subtitle": "Bestätigt, dass die letzte aktive Sitzung, das Transkript und der UI-Zustand einen Page-Refresh überstehen. Öffne diese Ansicht und drücke F5 — jede grüne Zeile sollte grün bleiben.",
    "recordProbe": "Probe aufzeichnen",
    "latestSession": "Letzte aktive Sitzung",
    "restoredLocal": "Aus localStorage wiederhergestellt",
    "sessionIdExtra": "Session-ID: {{id}}",
    "noSessionYet": "es wurde noch keine Sitzung gestartet",
    "activePointer": "Aktiver Session-Zeiger",
    "lastVisited": "lastVisitedAt-Zeitstempel",
    "never": "nie",
    "persistedEnv": "Persistierte Umgebung",
    "transcriptRehydrate": "Chat-Transkript-Rehydratation",
    "localTranscript": "Lokales Transkript wiederhergestellt",
    "messagesExtra": "{{count}} Nachrichten, {{queued}} in Warteschlange",
    "noMessages": "0 Nachrichten",
    "noBleed": "Kein Session-Übergriff",
    "bleedExtra": "gebunden={{bound}} vs aktiv={{active}}",
    "transcriptBinds": "Transkript bindet an die aktive Sitzung",
    "uiWorkspace": "UI-Workspace",
    "noneValue": "(keine)",
    "payloadSize": "localStorage-Payload (4 Schlüssel): {{count}} Zeichen",
    "probeLog": "Probe-Protokoll",
    "noProbes": "Noch keine Probes — drücke oben \"Probe aufzeichnen\" oder F5 in dieser Ansicht, um einen Rehydratations-Check aufzuzeichnen.",
    "simulatedF5": "simuliertes F5: persist rehydrate erneut ausführen"
  },
  "board": {
    "status": {
      "pending": "Ausstehend",
      "in_progress": "In Arbeit",
      "review": "Review",
      "failed": "Fehlgeschlagen",
      "completed": "Erledigt",
      "queued": "In Warteschlange",
      "blocked": "Blockiert",
      "cancelled": "Abgebrochen"
    },
    "newTaskTitle": "Neue Aufgabe",
    "newTaskPlaceholder": "Aufgabentitel…",
    "addTask": "Aufgabe hinzufügen",
    "empty": "Noch keine Phasen — starte einen AutoPhase-Lauf, um das Board zu füllen.",
    "summary": "{{phases}} Phasen · {{tasks}} Aufgaben",
    "phases": "Phasen",
    "statusTab": "Status",
    "dropHere": "Aufgaben hier ablegen",
    "emptySpec": "Noch keine Aufgaben in dieser Spec.",
    "depGraphHeading": "Abhängigkeitsgraph",
    "worktreePrefix": "Worktree: {{branch}}"
  },
  "debug": {
    "trendUp": "Steigend",
    "trendDown": "Fallend",
    "trendStable": "Stabil",
    "heading": "Debug-Dashboard",
    "subtitle": "Echtzeit-Monitoring für WrongStack WebUI",
    "refreshLabel": "Aktualisieren:",
    "lastUpdated": "Zuletzt aktualisiert: {{time}}",
    "fetchFailed": "Metriken konnten nicht abgerufen werden",
    "fileWatcher": "File-Watcher",
    "watcherStatus": "Watcher-Status",
    "running": "Läuft",
    "stopped": "Gestoppt",
    "activeProjects": "Aktive Projekte",
    "projectsWatched": "Überwachte Projekte",
    "fileChanges": "Dateiänderungen",
    "totalDetected": "Gesamt erkannt",
    "filesProcessed": "Verarbeitete Dateien",
    "afterHash": "Nach Hash-Filter",
    "broadcastsSent": "Gesendete Broadcasts",
    "toClients": "An WebUI-Clients",
    "debounceResets": "Debounce-Zurücksetzungen",
    "rapidWrites": "Schnelle aufeinanderfolgende Schreibvorgänge",
    "avgDebounce": "Ø Debounce-Verzögerung",
    "actualDelay": "Tatsächliche Verzögerung",
    "totalDelay": "Gesamtverzögerung",
    "sumDelays": "Summe aller Verzögerungen",
    "browserPerf": "Browser-Leistung",
    "heapUsed": "Heap verwendet",
    "jsHeap": "JavaScript-Heap",
    "heapTotal": "Heap gesamt",
    "totalHeap": "Gesamte Heap-Größe",
    "pageUptime": "Seiten-Laufzeit",
    "sinceLoad": "Seit Seitenladung",
    "rawData": "Rohdaten"
  },
  "providerModels": {
    "using": "Verwendet",
    "noModelPicked": "(kein Modell gewählt)",
    "clearAllowlist": "Allowlist löschen",
    "clearAllowlistAria": "Gespeicherte Allowlist für {{provider}} löschen",
    "refresh": "Vom Server aktualisieren",
    "refreshAria": "Modellliste für {{provider}} aktualisieren",
    "probing": "Prüfe…",
    "use": "Verwenden",
    "useModelAria": "Modell {{model}} für {{provider}} verwenden",
    "differsHint": "Die geprüfte Liste weicht von der gespeicherten Allowlist ab — führe {{command}} erneut aus, um zu speichern."
  },
  "dock": {
    "expandChip": "{{label}} ausklappen",
    "collapseChip": "{{label}} einklappen",
    "ahead": "{{count}} voraus",
    "behind": "{{count}} hinterher",
    "linesAdded": "{{count}} Zeilen hinzugefügt",
    "linesDeleted": "{{count}} Zeilen gelöscht",
    "untrackedFiles": "{{count}} unversionierte Dateien",
    "customizeTitle": "Dock-Chips anpassen",
    "dockChips": "Dock-Chips",
    "noActiveGoal": "Kein aktives Ziel",
    "noActiveGoalDetail": "Starte ein Ziel aus dem Chat oder dem Goal-Befehl."
  },
  "agentsMonitor": {
    "leaderBadge": "LEADER",
    "iters": "Iter.",
    "tools": "Tools",
    "activityBins": "Aktivität (12 Bins)",
    "streamingOutput": "Streaming-Ausgabe",
    "recentTools": "Letzte Tools",
    "finalOutput": "Endgültige Ausgabe",
    "heading": "Agents-Monitor",
    "prevAgent": "Vorheriger Agent",
    "nextAgent": "Nächster Agent",
    "closeAria": "Agents-Monitor schließen",
    "hintPage": "←→ Seite",
    "hintNavigate": "↑↓ Liste navigieren",
    "hintEsc": "Esc schließen"
  },
  "terminal": {
    "resize": "Terminals skalieren",
    "labelSingular": "Terminal",
    "labelPlural": "Terminals",
    "projectShell": "Projekt-Shell",
    "maxTerminals": "Maximal {{count}} Terminals",
    "newTerminal": "Neues Terminal",
    "restart": "Aktives Terminal neu starten",
    "closeAll": "Alle Terminals schließen",
    "closeDock": "Terminal-Dock schließen (Ctrl+`)",
    "closeTab": "{{name}} schließen",
    "processExited": "[Prozess mit Code {{code}} beendet]"
  },
  "sessionWatch": {
    "liveStream": "Live-Stream",
    "events_one": "{{count}} Ereignis",
    "events_other": "{{count}} Ereignisse",
    "interruptTitle": "Diesen Agenten kooperativ beim nächsten Schritt stoppen (kein Process-Kill)",
    "interrupt": "⏸ Unterbrechen",
    "interrupting": "…",
    "loading": "Sitzung wird geladen…",
    "done": "✓✓ erledigt",
    "read": "✓ gelesen",
    "delivered": "⏳ zugestellt",
    "agent": "Agent",
    "you": "Du",
    "working": "{{name}} · arbeitet",
    "claude": "Claude",
    "priority": "Priorität",
    "placeholder": "{{label}} → an diese Sitzung…",
    "send": "Senden",
    "sendHint": "⌘/Ctrl+Enter zum Senden · beim nächsten Iterationsschritt des Agenten sichtbar",
    "msgType": {
      "steerLabel": "🔄 Lenken",
      "steerHint": "Verhalten während der Aufgabe anpassen",
      "askLabel": "❓ Fragen",
      "askHint": "Frage — erwartet eine Antwort",
      "assignLabel": "📋 Zuweisen",
      "assignHint": "Eine zu erledigende Aufgabe",
      "noteLabel": "💬 Notiz",
      "noteHint": "Zur Info, nicht dringend"
    },
    "sentRunning": "Zugestellt — der laufende Agent sieht es beim nächsten Schritt",
    "sentIdle": "Zugestellt — Ziel ist inaktiv; erscheint im Postfach, gelesen beim nächsten Lauf",
    "sentFailed": "Fehlgeschlagen: {{error}}",
    "interruptReason": "Operator hat Stopp aus Fleet HQ angefordert",
    "interruptSent": "Unterbrechung gesendet — Agent stoppt beim nächsten Schritt (kein Kill)",
    "interruptFailed": "Unterbrechung fehlgeschlagen: {{error}}"
  },
  "sideEffects": {
    "empty": "Noch keine Seiteneffekte aufgezeichnet.",
    "emptyHint": "Bash-Befehle, Paketinstallationen und Netzwerkanfragen erscheinen hier.",
    "heading": "Seiteneffekte",
    "exportTitle": "Gefilterte Seiteneffekte als CSV exportieren",
    "all": "Alle",
    "colTime": "Zeit",
    "colTool": "Tool",
    "colRisk": "Risiko",
    "colDetail": "Detail",
    "colOutcome": "Ergebnis"
  },
  "monitor": {
    "elapsedHm": "vor {{h}}h {{m}}m",
    "elapsedMs": "vor {{m}}m {{s}}s",
    "elapsedS": "vor {{s}}s",
    "heading": "Fleet-Monitor",
    "clientsHeading": "Verbundene Clients",
    "terminal": "Terminal",
    "webui": "Web-UI",
    "repl": "REPL",
    "totalConnected": "insgesamt verbunden",
    "mailQueue": "Mail-Warteschlange",
    "total": "Gesamt",
    "open": "Offen",
    "unread": "Ungelesen",
    "agents": "Agents",
    "messagesSub": "Nachrichten",
    "uncompletedSub": "unabgeschlossen",
    "waitingSub": "wartend",
    "ofTotal": "von {{count}} gesamt",
    "agentRoster": "Agenten-Roster",
    "liveMailActivity": "Live-Mail-Aktivität",
    "noActivity": "Keine aktuelle Aktivität",
    "mailboxAgents": "Mailbox-Agents",
    "noMailboxAgents": "Keine Agents registriert",
    "moreCount": "+{{count}} weitere",
    "agentFallback": "Agent",
    "fleetAgents": "Fleet-Agents",
    "noFleetAgents": "Keine Fleet-Agents aktiv",
    "iter": "Iter.",
    "mailType": {
      "sent": "Gesendet",
      "delivered": "Zugestellt",
      "read": "Gelesen",
      "completed": "Abgeschlossen"
    }
  },
  "sdd": {
    "status": {
      "pending": "ausstehend",
      "queued": "in Warteschlange",
      "in_progress": "läuft",
      "blocked": "blockiert",
      "review": "Review",
      "failed": "fehlgeschlagen",
      "completed": "erledigt",
      "cancelled": "abgebrochen"
    },
    "activityHeading": "Aktivität",
    "feedEmpty": "Noch nichts — Ereignisse erscheinen hier, sobald Agents Aufgaben übernehmen und abschließen.",
    "destroyTitle": "SDD-Projekt zerstören?",
    "destroyDesc": "Das löscht den Run und seine Arbeit. Nicht rückgängig zu machen (das optionale Commit-Revert ist historienwahrend).",
    "stopRun": "Run stoppen",
    "stopRunAgents_one": "Run stoppen ({{count}} Agent arbeitet)",
    "stopRunAgents_other": "Run stoppen ({{count}} Agents arbeiten)",
    "removeWorktreesAll": "Alle Git-Worktrees + wstack/ap/*-Branches entfernen — inklusive nicht gemergter Arbeit",
    "removeWorktreesCount_one": "{{count}} Git-Worktree + wstack/ap/*-Branches entfernen — inklusive nicht gemergter Arbeit",
    "removeWorktreesCount_other": "{{count}} Git-Worktrees + wstack/ap/*-Branches entfernen — inklusive nicht gemergter Arbeit",
    "deleteArtifacts": "Alle SDD-Artefakte löschen (Specs, Task-Graph, Board, Session)",
    "revertMerged_one": "Auch {{count}} gemergtes Commit revertieren",
    "revertMerged_other": "Auch {{count}} gemergte Commits revertieren",
    "revertHint": "Fügt Revert-Commits hinzu (Historie bleibt). Wird verweigert, wenn der Working Tree dirty ist.",
    "baseBranchFallback": "der Basis-Branch",
    "noteLeaveMerged": "Gemergte Commits bleiben auf dem Basis-Branch. Setze den Haken oben, um sie auch rückgängig zu machen.",
    "noteAbandon": "Stelle sicher, dass du diesen Run wirklich aufgeben willst.",
    "destroying": "Zerstöre…",
    "destroyAll": "Alles zerstören",
    "kanbanBacklog": "Backlog",
    "kanbanReady": "Bereit",
    "kanbanRunning": "Läuft",
    "kanbanReview": "Review",
    "kanbanFailed": "Fehlgeschlagen",
    "kanbanDone": "Erledigt",
    "kanbanEmpty": "leer"
  },
  "toolResult": {
    "collapseToLines": "Auf erste {{count}} Zeilen einklappen",
    "showAllLines": "Alle {{total}} Zeilen anzeigen ({{more}} mehr)",
    "exitCode": "Exit-Code:",
    "jsonLines": "JSON · {{count}} Zeilen",
    "collapse": "einklappen",
    "expand": "ausklappen"
  },
  "design": {
    "heading": "Design Studio — Galerie",
    "kitsCount": "{{count}} Kits",
    "searchPlaceholder": "Kits suchen…",
    "stackTitle": "Stack für Use + Materialize",
    "wrote": "{{path}} geschrieben",
    "materializeFailed": "Materialize fehlgeschlagen: {{error}}",
    "verifyError": "Prüfen: {{error}}",
    "verifyOffPalette": "Prüfen: {{pct}}% on-palette — {{count}} off-palette in {{files}} Datei(en)",
    "verifyClean": "Prüfen: sauber ✓ ({{files}} Datei(en) on-palette)",
    "writing": "Theme-Datei wird geschrieben…",
    "scanning": "UI-Dateien werden gescannt…",
    "active": "Aktiv",
    "reapply": "Erneut anwenden",
    "use": "Verwenden",
    "materializeTitle": "Tokens in eine {{stack}}-Theme-Datei schreiben",
    "materialize": "Materialisieren",
    "verifyTitle": "UI-Dateien auf Off-Palette-Farben prüfen",
    "verify": "Prüfen",
    "colors": "Farben"
  },
  "autoPhase": {
    "summary_one": "{{count}} Phase · {{pct}}% fertig",
    "summary_other": "{{count}} Phasen · {{pct}}% fertig",
    "switchBoard": "Board wechseln",
    "boardsCount_one": "{{count}} Board…",
    "boardsCount_other": "{{count}} Boards…",
    "toggleAutonomousTitle": "Autonomen Modus umschalten",
    "autonomous": "Autonom",
    "manual": "Manuell",
    "resumeTitle": "Lauf fortsetzen",
    "pauseTitle": "Lauf pausieren",
    "resume": "Fortsetzen",
    "pause": "Pausieren",
    "stopTitle": "Lauf stoppen — bricht laufende Agents sofort ab",
    "stop": "Stopp",
    "newTitle": "Dieses Board löschen und einen neuen AutoPhase-Lauf starten",
    "newLabel": "Neu",
    "revertConfirm": "Commits des Laufs zurücksetzen?",
    "revertTitle": "Diesen Lauf zurücknehmen — gelandete Commits per git-revert und Worktrees entfernen",
    "revert": "Zurücknehmen",
    "goal": "Ziel",
    "planning": "Phasen werden geplant…",
    "planningBody": "Dein Ziel wurde empfangen. WrongStack zerlegt es in Phasen und Aufgaben — das Board erscheint hier, sobald der Plan steht.",
    "startHeading": "Phasenplan starten",
    "startBody": "Beschreibe, was du bauen willst. WrongStack plant Phasen und Aufgaben und führt sie aus — beobachte und lenke den Lauf auf dem Board.",
    "startPlaceholder": "z.B. Eine REST-API für Benutzerverwaltung mit Express und SQLite bauen...",
    "isolateLabel": "Jede Phase im eigenen Git-Worktree isolieren",
    "startButton": "AutoPhase starten",
    "ctrlHint": "Ctrl+Enter zum Starten",
    "isolateOn": "Phasen laufen in isolierten Worktrees, squash-merged zurück",
    "isolateOff": "Phasen laufen direkt auf dem aktuellen Branch",
    "lanes": "Spuren",
    "graph": "Graph",
    "planningAck": "🚀 **AutoPhase** — verstanden. Plane Phasen für dein Ziel…"
  },
  "collab": {
    "noObservers": "Keine Live-Beobachter",
    "observerTitle": "Als nur-lesen-Beobachter beitreten (Phase 1)",
    "observerRole": "Beobachter",
    "annotatorTitle": "Als Annotator beitreten — hinterlasse Notizen zu Tool-Aufrufen (Phase 2)",
    "annotatorRole": "Annotator",
    "controllerTitle": "Als Controller beitreten — kann die Agent-Schleife pausieren (Phase 3)",
    "controllerRole": "Controller",
    "errorPrefix": "Collab: {{error}}",
    "dismiss": "verwerfen",
    "observers_one": "{{count}} Beobachter",
    "observers_other": "{{count}} Beobachter",
    "annotationsTitle": "{{count}} offene Anmerkung(en) — Annotatoren prüfen diese Sitzung",
    "notes_one": "{{count}} Notiz",
    "notes_other": "{{count}} Notizen",
    "pausedTitle": "Agent-Schleife pausiert — ein Controller prüft",
    "paused": "pausiert",
    "joinedTitle": "Beigetreten {{time}}",
    "grantTitle": "Kontrolle geben — diesen Teilnehmer zum Controller befördern",
    "injectTitle": "Ein synthetisches Ergebnis für einen laufenden Tool-Aufruf injizieren",
    "inject": "Injizieren",
    "resumeTitle": "Agent-Schleife fortsetzen",
    "resume": "Fortsetzen",
    "pauseTitle": "Agent vor dem nächsten Tool-Aufruf pausieren",
    "pauseAgent": "Agent pausieren",
    "leaveTitle": "Beobachter-Sitzung verlassen",
    "leave": "Verlassen",
    "injectToolResult": "Tool-Ergebnis injizieren",
    "close": "schließen",
    "targetTool": "Ziel-tool_use-id",
    "targetPlaceholder": "laufenden Aufruf wählen oder tool_use-id eingeben",
    "toolFallback": "Tool",
    "noPendingTools": "Keine laufenden Tool-Aufrufe — gib eine tool_use-id ein oder pausiere den Agent zuerst.",
    "resultContent": "Ergebnisinhalt",
    "resultPlaceholder": "Synthetisches Tool-Ergebnis, das dem Agent statt der Ausführung zugeführt wird",
    "markError": "als Fehler markieren",
    "reasonPlaceholder": "Grund (Audit-Log)",
    "queueInjection": "Injektion einreihen",
    "controllerInjection": "Controller-Injektion"
  },
  "connection": {
    "reconnecting": "Verbinde erneut mit Backend (Versuch {{attempt}}) — erneut in {{remaining}} s",
    "disconnected": "Verbindung zum Backend getrennt",
    "retry": "Jetzt erneut versuchen",
    "retryTitle": "Verbindung jetzt erneut versuchen",
    "dismissTitle": "Verwerfen (Chip in der Topbar zeigt weiterhin den Status)"
  },
  "mode": {
    "modePrefix": "Modus:",
    "activeTitle": "Aktiver Modus",
    "heading": "Modus",
    "defaultName": "Standard",
    "defaultDesc": "Standard-Agent-Verhalten"
  },
  "cost": {
    "clickTitle": "Klicken für Kostenaufschlüsselung pro Zug",
    "heading": "Kostenaufschlüsselung",
    "noPricing": "Keine Preisgebung für das aktuelle Modell — Kostenwerte sind null.",
    "noTurns": "Noch keine abgeschlossenen Züge. Führe einen Prompt aus, um hier die Kosten pro Zug zu sehen.",
    "topExpensive_one": "Teuerster Zug",
    "topExpensive_other": "Die {{count}} teuersten Züge"
  },
  "model": {
    "runDefault": "Run-Standard",
    "useRunDefault": "Run-Standard verwenden",
    "filterPlaceholder": "Modelle filtern…",
    "loading": "Modelle werden geladen…",
    "noMatch": "Kein Treffer"
  },
  "modelSwitcher": {
    "filterPlaceholder": "Anbieter und Modelle filtern…",
    "noSavedProviders": "Keine gespeicherten Anbieter — zuerst einen Schlüssel in den Einstellungen registrieren.",
    "active": "aktiv"
  },
  "work": {
    "todos": "Todos",
    "tasks": "Aufgaben",
    "plan": "Plan"
  },
  "todos": {
    "toggleAria": "Umschalten: {{content}}",
    "removeTitle": "Todo entfernen",
    "removeAria": "\"{{content}}\" entfernen",
    "completedCount_one": "{{count}} erledigt",
    "completedCount_other": "{{count}} erledigt"
  },
  "task": {
    "start": "Starten",
    "complete": "Abschließen",
    "retry": "Erneut versuchen",
    "assign": "Zuweisen",
    "assignTitle": "Agent zuweisen",
    "unassigned": "Nicht zugewiesen",
    "statusPending": "Ausstehend",
    "statusInProgress": "In Arbeit",
    "statusBlocked": "Blockiert",
    "statusFailed": "Fehlgeschlagen",
    "statusReview": "Review",
    "statusDone": "Erledigt",
    "startTitle": "Starten",
    "completeTitle": "Abschließen",
    "fail": "Fehlschlagen",
    "failTitle": "Als fehlgeschlagen markieren",
    "boardCount": "{{total}} Aufgaben · {{done}} erledigt"
  },
  "toolGroup": {
    "toolCalls_one": "{{count}} Werkzeugaufruf",
    "toolCalls_other": "{{count}} Werkzeugaufrufe"
  },
  "fileRef": {
    "removeTitle": "Referenz entfernen",
    "linesCount_one": "{{count}} Zeile",
    "linesCount_other": "{{count}} Zeilen"
  },
  "plan": {
    "statusOpen": "Offen",
    "statusInProgress": "In Arbeit",
    "statusDone": "Erledigt",
    "startTitle": "Starten",
    "doneTitle": "Als erledigt markieren",
    "reopenTitle": "Wieder öffnen",
    "reopen": "Wieder öffnen"
  },
  "filePicker": {
    "heading": "@ Dateien",
    "noMatch": "Keine Dateien passen zu „{{query}}“",
    "searching": "Projekt wird durchsucht…"
  },
  "toast": {
    "dismiss": "Verwerfen"
  },
  "search": {
    "placeholder": "Im Chat suchen…",
    "prevHit": "Vorheriger Treffer",
    "nextHit": "Nächster Treffer",
    "close": "Schließen (Esc)"
  },
  "phase": {
    "statusPending": "Ausstehend",
    "statusReady": "Bereit",
    "statusRunning": "Läuft",
    "statusPaused": "Pausiert",
    "statusCompleted": "Abgeschlossen",
    "statusFailed": "Fehlgeschlagen",
    "statusSkipped": "Übersprungen",
    "heading": "Phasen",
    "autonomousOn": "● Autonom",
    "autonomousOff": "○ Manuell",
    "autonomousOnTitle": "Autonomer Modus aktiv — klicken zum Pausieren",
    "autonomousOffTitle": "Manueller Modus — klicken zum Aktivieren des autonomen Modus",
    "overallProgress": "Gesamtfortschritt",
    "tasksSuffix": "{{done}}/{{total}} Aufgaben",
    "agentsSuffix_one": "{{count}} Agent",
    "agentsSuffix_other": "{{count}} Agents"
  },
  "ctxMode": {
    "triggerTitle": "Kontextfenster-Modus",
    "ctxPrefix": "ctx:",
    "opsHeading": "Kontextoperationen",
    "compactNow": "Jetzt komprimieren",
    "compactNowDesc": "Alte Tool-Ausgaben kürzen",
    "compactAggressive": "Aggressiv komprimieren",
    "compactAggressiveDesc": "Maximale Kürzung jetzt",
    "repairContext": "Kontext reparieren",
    "repairDesc": "Verwaiste Tool-Use-Blöcke beheben",
    "debugContext": "Kontext debuggen",
    "debugDesc": "Größenaufschlüsselung pro Abschnitt",
    "windowHeading": "Kontextfenster",
    "keepElide": "{{k}} letzte behalten · {{t}}+ Token kürzen",
    "fallbackName": "Ausgeglichen",
    "fallbackDesc": "Standard-Rolling-Komprimierung"
  },
  "transcript": {
    "kindAssistant": "Assistent",
    "kindThinking": "Denken",
    "kindToolCall": "Werkzeugaufruf",
    "kindToolResult": "Werkzeugergebnis",
    "kindError": "Fehler",
    "kindStatus": "Status",
    "kindSystem": "System",
    "title": "Chat-Verlauf",
    "copyTitle": "Agenten-Chatverlauf kopieren",
    "empty": "Noch kein Chat-Verlauf für diesen Agenten."
  },
  "autonomy": {
    "heading": "Autonomiemodus",
    "titlePrefix": "Autonomie: {{label}}",
    "descOff": "Volle manuelle Kontrolle — Agent wartet auf deine Eingabe.",
    "descSuggest": "Agent schlägt nächste Schritte vor, wartet aber auf Genehmigung.",
    "descAuto": "Agent setzt nach kurzer Bestätigungsverzögerung automatisch fort.",
    "descEternal": "Agent läuft autonom, bis das Ziel erreicht ist.",
    "descEternalParallel": "Multi-Agenten autonome Ausführung — Fleet-Modus."
  },
  "queue": {
    "heading": "Nachrichtenwarteschlange",
    "subtitle": "{{count}} in Warteschlange · Nachrichten werden gesendet, bevor der Agent fertig ist",
    "btwTitle": "Nebenbei — als Folgenachricht gesendet, ohne den laufenden Agent zu unterbrechen",
    "steerTitle": "Lenken — unterbricht den laufenden Agent und leitet ihn mit dieser Nachricht um",
    "queueTitle": "Eingereiht — zurückgehalten bis der aktuelle Agent-Lauf endet, dann in Reihenfolge gesendet",
    "sortNewestTitle": "Nach neuesten sortiert — klicken für älteste zuerst",
    "sortOldestTitle": "Nach ältesten sortiert — klicken für neueste zuerst",
    "newest": "Neueste",
    "oldest": "Älteste",
    "clear": "Leeren",
    "clearTitle": "Alle Nachrichten aus der Warteschlange löschen",
    "closeTitle": "Schließen",
    "emptyTitle": "Warteschlange ist leer",
    "emptyBody": "Nutze die btw-/steer-/„Zur Warteschlange“-Schaltflächen neben der Eingabe, um Nachrichten hinzuzufügen. Eingereihte Einträge werden in Reihenfolge gesendet, wenn der aktuelle Agent-Lauf endet.",
    "removeTitle": "Aus Warteschlange entfernen",
    "footer": "Nachrichten werden in Ankunftsreihenfolge gesendet, wenn der aktuelle Agent-Lauf endet. Nutze die Sortierung, um neueste zuerst zu sehen."
  },
  "checkpoint": {
    "heading": "Sitzungs-Checkpoints",
    "countSuffix_one": "{{count}} Checkpoint",
    "countSuffix_other": "{{count}} Checkpoints",
    "description": "Sitzung zu einem beliebigen Checkpoint zurückspulen. Nachrichten und Dateiänderungen kehren zu diesem Punkt zurück — das LLM setzt von dort fort, als wäre nichts danach passiert.",
    "emptyTitle": "Noch keine Checkpoints",
    "emptyBody": "Checkpoints werden automatisch bei jeder gesendeten Nachricht erstellt. Sende ein paar Nachrichten und komme zurück.",
    "latest": "aktuell",
    "msgSuffix_one": "{{count}} Nachricht",
    "msgSuffix_other": "{{count}} Nachrichten",
    "footerPre": "Beliebigen Checkpoint zum Zurückspulen klicken",
    "footerPost": "zum Schließen"
  },
  "goal": {
    "statusActive": "Aktiv",
    "statusPaused": "Pausiert",
    "statusDone": "Erledigt",
    "statusFailed": "Fehlgeschlagen",
    "statusAbandoned": "Aufgegeben",
    "heading": "Ziel",
    "refined": "Verfeinert",
    "progress": "Fortschritt",
    "iterations": "Iterationen",
    "deliverables": "Lieferobjekte",
    "recentActivity": "Letzte Aktivität"
  },
  "worktree": {
    "cleanTitle_one": "{{count}} verwaisten Worktree entfernen?",
    "cleanTitle_other": "{{count}} verwaiste Worktrees entfernen?",
    "cleanMessage": "Entfernt jeden übriggebliebenen Git-Worktree + wstack/ap-Branch vorheriger Läufe zwangsweise. Nicht gemergte Arbeit darin geht verloren.",
    "cleanConfirm": "Verwaiste entfernen",
    "orphanCount_one": "{{count}} verwaister Worktree aus vorherigen Läufen",
    "orphanCount_other": "{{count}} verwaiste Worktrees aus vorherigen Läufen",
    "andMore": "…und {{count}} weitere",
    "cleanButtonTitle": "Alle verwaisten Worktrees + Branches zwangsweise entfernen",
    "removed_one": "✓ {{count}} verwaister Worktree entfernt.",
    "removed_other": "✓ {{count}} verwaiste Worktrees entfernt.",
    "cleanupFailed": "Bereinigung fehlgeschlagen",
    "lanesHeading": "Worktrees",
    "base": "Basis",
    "isolatedCount_one": "{{count}} isoliert",
    "isolatedCount_other": "{{count}} isoliert",
    "statusAllocating": "zuweisend",
    "statusActive": "aktiv",
    "statusCommitting": "committend",
    "statusMerging": "mergend",
    "statusMerged": "gemergt",
    "statusConflict": "Konflikt",
    "statusFailed": "fehlgeschlagen",
    "conflictBadge": "KONFLIKT",
    "graphAria": "Worktree-Branch-Graph ab {{base}}",
    "mergedLabel": "✓ gemergt → {{base}}"
  },
  "process": {
    "heading": "Laufende Prozesse",
    "subtitle": "{{active}} aktiv · {{total}} gesamt",
    "killAll": "Alle beenden",
    "emptyTitle": "Keine Prozesse verfolgt",
    "emptyBody": "Prozesse erscheinen hier, wenn der Agent bash- oder exec-Tools ausführt. Aktive Prozesse zeigen eine pulsierende LED.",
    "pidLabel": "PID {{pid}}",
    "protected": "geschützt",
    "protectedTitle": "Geschützt — überlebt kill/killAll",
    "killTitle": "PID {{pid}} beenden"
  },
  "diff": {
    "tooLarge": "Diff ausgelassen (Datei zu groß für die Inline-Darstellung)."
  },
  "fallback": {
    "placeholder": "Ausweichmodell hinzufügen…",
    "emptyHint": "Wird in Reihenfolge versucht, wenn das primäre Modell ratelimitiert oder hängt.",
    "moveUp": "Nach oben",
    "moveDown": "Nach unten",
    "manualPlaceholder": "anbieter/modell",
    "addTitle": "Modellreferenz hinzufügen"
  },
  "liveSessions": {
    "loading": "Sitzungen werden geladen...",
    "apiUnavailable": "Sitzungs-API nicht verfügbar:",
    "empty": "Keine Live-Sitzungen. Öffne eine weitere wstack-Instanz, um sie hier zu sehen.",
    "heading": "Live-Sitzungen ({{count}})",
    "autoRefresh": "Auto-Aktualisierung alle 5 s",
    "pidLabel": "PID {{pid}}",
    "agentMeta": "{{iter}} Iterationen · {{tools}} Tools · {{ago}}",
    "andMore": "... und {{count}} weitere",
    "noAgents": "Keine Agents"
  },
  "monacoDiff": {
    "applyTitle": "Die bearbeitete Version auf die Festplatte schreiben",
    "applying": "Anwenden…",
    "applied": "Angewandt",
    "apply": "Anwenden"
  },
  "errorBody": {
    "showStack_one": "Stack-Trace zeigen ({{count}} Frame)",
    "showStack_other": "Stack-Trace zeigen ({{count}} Frames)",
    "hideStack_one": "Stack-Trace verbergen ({{count}} Frame)",
    "hideStack_other": "Stack-Trace verbergen ({{count}} Frames)"
  },
  "officeMap": {
    "liveHeading": "Live",
    "clients": "Clients",
    "agents": "Agents",
    "model": "Modell",
    "mode": "Modus",
    "toolCalls": "Tool-Aufrufe",
    "displayHeading": "Anzeige",
    "statsHud": "Stats-HUD",
    "legends": "Legenden",
    "minimap": "Minimap",
    "zoomControls": "Zoom-Steuerung",
    "animateWires": "Kabel animieren",
    "backgroundHeading": "Hintergrund",
    "bgDots": "Punkte",
    "bgLines": "Linien",
    "bgCross": "Kreuz",
    "bgNone": "Keine"
  },
  "toolInput": {
    "noParams": "(keine Parameter)",
    "itemCount_one": "{{count}} Element",
    "itemCount_other": "{{count}} Elemente",
    "keyCount_one": "{{count}} Schlüssel",
    "keyCount_other": "{{count}} Schlüssel"
  },
  "message": {
    "roleYou": "Du",
    "roleTool": "Tool",
    "roleThinking": "Denken",
    "roleAssistant": "Assistent",
    "inputLabel": "Eingabe",
    "downloadTitle": "Als Datei herunterladen",
    "empty": "(leer)",
    "hideDetails": "Details verbergen",
    "showDetails": "Details zeigen",
    "showDetailsLines_one": "Details zeigen ({{count}} Zeile)",
    "showDetailsLines_other": "Details zeigen ({{count}} Zeilen)",
    "editHint": "⌘/Ctrl+Enter zum Speichern · Esc zum Abbrechen",
    "saveResend": "Speichern & erneut senden",
    "thinkingProcess": "Denkprozess",
    "thinkingMeta": "Iter {{iter}} · {{dur}} · {{lines}}",
    "replay": "Replay",
    "linesSuffix_one": "{{count}} Zeile",
    "linesSuffix_other": "{{count}} Zeilen",
    "copyLog": "Log kopieren",
    "showFullLog": "Vollständiges Log zeigen",
    "typing": "Tippt…",
    "noContent": "Kein Inhalt",
    "failedToSend": "⚠ Senden fehlgeschlagen",
    "autoPaused": "⚠️ _Auto-Fortsetzen pausiert — maximale aufeinanderfolgende automatische Züge erreicht. Tippe etwas zum Fortfahren (Autonomie bleibt an)._",
    "rsIterations": "Iterationen: {{n}}",
    "rsTools": "Tool-Aufrufe: {{n}}",
    "rsElapsed": "Verstrichen: {{s}}",
    "rsCost": "Kosten: {{c}}",
    "useInput": "Eingabe: {{n}}",
    "useOutput": "Ausgabe: {{n}}",
    "useCacheRead": "Cache-Lesung: {{n}}",
    "useCost": "Kosten: {{c}}",
    "renderedLabel": "Gerendert",
    "rawLabel": "Raw",
    "showRenderedTitle": "Gerendertes Markdown zeigen",
    "showRawTitle": "Raw-Markdown-Quelle zeigen",
    "editTitle": "Diesen Prompt bearbeiten & erneut senden",
    "editLabel": "Bearbeiten",
    "unpinTitle": "Lösen",
    "pinTitle": "Diese Antwort anheften",
    "pinnedLabel": "Angeheftet",
    "pinLabel": "Anheften",
    "regenerateTitle": "Diese Antwort neu generieren",
    "retryLabel": "Erneut versuchen"
  },
  "watch": {
    "toolFallback": "Tool",
    "toolFailed": "Tool fehlgeschlagen"
  },
  "shortcuts": {
    "heading": "Tastaturkürzel",
    "footerPre": "Jederzeit",
    "footerPost": "drücken, um diese Liste wieder zu öffnen.",
    "sectionGlobal": "Global",
    "sectionTuiParity": "TUI-Panel-Parität",
    "sectionFleet": "Fleet & Agents",
    "sectionChatInput": "Chat-Eingabe",
    "sectionChat": "Chat",
    "sectionChatNav": "Chat-Navigation (beim Nicht-Tippen)",
    "dCommandPalette": "Befehls-Palette öffnen",
    "dShowOverlay": "Diese Kürzel-Overlay zeigen",
    "dToggleSidebar": "Seitenleiste umschalten",
    "dOpenPanel": "Seitenleiste öffnen (Session, Agents, Verlauf, Dateien, Changes, Mailbox, Skills, Office Map)",
    "dDesignStudio": "Design-Studio-Seitenleiste öffnen",
    "dWorktrees": "Worktree-Seitenleiste öffnen",
    "dFocusInput": "Nachrichteneingabe fokussieren",
    "dSessionPanel": "Session-Panel",
    "dFleetOverlay": "Fleet-Monitor-Overlay",
    "dAgentsOverlay": "Agents-Monitor-Overlay",
    "dWorktreeMonitor": "Worktree-Monitor",
    "dPlanPanel": "Plan-Panel",
    "dTodosPanel": "Todos-Panel",
    "dQueuePanel": "Queue-Panel",
    "dProcessMonitor": "Prozess-Monitor",
    "dGoalPanel": "Ziel-Panel",
    "dSessionsDashboard": "Session-Dashboard",
    "dOfficeMap": "Koordinator-Office-Map",
    "dDockPicker": "Dock-Chip-Wähler",
    "dOpenFleet": "Fleet-Monitor-Overlay öffnen",
    "dOpenAgents": "Agents-Monitor-Overlay öffnen",
    "dNavigateAgents": "Agents im Monitor navigieren",
    "dSelectAgent": "Fokussierten Agent wählen",
    "dCloseOverlay": "Aktives Overlay schließen",
    "dSendMessage": "Nachricht senden",
    "dNewline": "Zeilenumbruch einfügen",
    "dRecallPrev": "Vorherigen Prompt abrufen (bei leerer Eingabe)",
    "dRecallNext": "Nächsten Prompt abrufen",
    "dSlashPopup": "Slash-Befehl-Popup öffnen",
    "dAutocomplete": "Hervorgehobenen Befehl autovervollständigen",
    "dDismissPopup": "Popup schließen / Eingabe löschen",
    "dSearchChat": "Im aktuellen Chat suchen",
    "dClearContext": "Kontext löschen (wie /clear)",
    "dNewSession": "Neue Session starten (wie /new)",
    "dExportMarkdown": "Chat als Markdown exportieren",
    "dModelSwitcher": "Quick-Model-Switcher-Overlay",
    "dCompactDensity": "Kompakte UI-Dichte umschalten",
    "dAbortRun": "Aktuellen Run abbrechen (während läuft)",
    "dFocusNext": "Nächste Nachricht fokussieren (Alias: ↓)",
    "dFocusPrev": "Vorherige Nachricht fokussieren (Alias: ↑)",
    "dJumpFirst": "Zur ersten Nachricht springen",
    "dJumpLast": "Zur letzten Nachricht springen",
    "dCopyFocused": "Fokussierten Nachrichtentext kopieren",
    "dClearFocused": "Fokussierte Nachricht löschen"
  },
  "sddBoard": {
    "titleFallback": "Live SDD Board",
    "defaultModelTitle": "Run-Standard-Workermodell (pro-Task-Overrides haben Vorrang)",
    "graphLabel": "Graph",
    "kanbanLabel": "Kanban",
    "retryAllTitle": "Jede fehlgeschlagene Task zurück in pending einreihen",
    "retryFailed": "Fehlgeschlagene erneut ({{count}})",
    "resume": "Fortsetzen",
    "pause": "Pausieren",
    "stop": "Stopp",
    "cleanTitle": "Git-Worktrees + wstack/ap-Branches des Runs entfernen",
    "cleanWorktrees": "Worktrees bereinigen",
    "rollbackTitle": "{{count}} gemergte(s) Commit(s) auf {{base}} revertieren",
    "rollback": "Rollback ({{count}})",
    "stopping": "Stoppt…",
    "destroying": "Zerstört…",
    "destroyTitle": "Stoppen, alle Worktrees entfernen, optional gemergte Commits revertieren und das SDD-Projekt löschen",
    "destroy": "Zerstören",
    "statDone": "fertig",
    "statRunning": "läuft",
    "statFailed": "fehlgeschlagen",
    "statWave": "welle",
    "statElapsed": "verstrichen",
    "noActiveWorkers": "keine aktiven Worker",
    "deadlock": "Deadlock — Tasks blockiert durch fehlgeschlagene Arbeit:",
    "noRunTitle": "Kein aktiver SDD-Run.",
    "noRunBody": "Starte einen im New-SDD-Project-Assistenten oder per /sdd execute in der CLI — Agents erscheinen hier live, jeder in einem isolierten Worktree.",
    "clickTaskHint": "Task für Details klicken",
    "lcClean": "Bereinigen",
    "lcRollback": "Rollback",
    "lcDestroy": "Zerstören",
    "lcFailed": "{{op}} fehlgeschlagen: {{reason}}",
    "lcUnknownError": "unbekannter Fehler",
    "lcWorktrees_one": "{{count}} Worktree entfernt",
    "lcWorktrees_other": "{{count}} Worktrees entfernt",
    "lcCommits_one": "{{count}} Commit revertiert",
    "lcCommits_other": "{{count}} Commits revertiert",
    "lcDeleted": "gelöscht {{items}}",
    "lcNothing": "nichts zu tun",
    "lcNote": "{{op}}: {{body}} — Hinweis: {{reason}}",
    "lcOk": "{{op}}: {{body}}"
  },
  "sddTask": {
    "backTitle": "Zur Aktivität zurück",
    "workingOn": "arbeitet an dieser Task",
    "assigned": "zugewiesen",
    "metaPriority": "Priorität",
    "metaType": "Typ",
    "metaDuration": "Dauer",
    "metaElapsed": "Verstrichen",
    "metaRetries": "Versuche",
    "metaWorktree": "Worktree",
    "workerModel": "Worker-Modell",
    "runDefault": "Run-Standard: {{model}}",
    "runDefaultPlaceholder": "Run-Standard",
    "runDefaultPlaceholderModel": "Run-Standard ({{model}})",
    "verificationCmd": "Verifikationsbefehl",
    "gatesCompletion": "schließt Completion ab (exit 0)",
    "verifyPlaceholder": "z. B. pnpm vitest run path/to/file",
    "addVerify": "+ Verifikationsbefehl hinzufügen",
    "description": "Beschreibung",
    "timeline": "Zeitleiste",
    "dependsOn": "Hängt ab von",
    "blocks": "Blockiert",
    "newWorkerPlaceholder": "Neuer Worker-Name…",
    "confirmStop": "Diese laufende Task stoppen?",
    "confirmDelete": "Diese Task aus dem Run löschen?",
    "retryTitle": "Diese Task zurück in pending einreihen",
    "reassign": "Neu zuweisen",
    "stopTitle": "Den Worker auf dieser Task abbrechen",
    "splitTitle": "Diese Task in separate Worker-Sub-Tasks aufteilen",
    "split": "Aufteilen",
    "splitHint": "Eine Sub-Task pro Zeile — Titel :: Beschreibung (Beschreibung optional)",
    "splitPlaceholder": "Datenlayer schreiben :: Repository hinzufügen\nUI verdrahten",
    "splitInto": "In Sub-Tasks aufteilen",
    "deleteTitle": "Diese nicht gestartete Task aus dem Run entfernen"
  },
  "sddWizard": {
    "phaseStart": "Start",
    "phaseInterview": "Interview",
    "phaseSpecReview": "Spec-Review",
    "phasePlanning": "Planung",
    "phaseTaskReview": "Task-Review",
    "phaseRunning": "Läuft",
    "phaseDone": "Fertig",
    "titleFallback": "Neues SDD-Projekt",
    "questionsSuffix": "{{cur}}/{{max}} Fragen",
    "tasksSuffix": "{{count}} Tasks",
    "runCfgTitle": "Run-Konfiguration — Standardmodell + Fallback-Kette",
    "modelsLabel": "Modelle",
    "startRun": "Run starten",
    "defaultWorkerModel": "Standard-Worker-Modell",
    "leaderDefaultPlaceholder": "Leader / Session-Standard",
    "useSessionDefault": "Session-Standard verwenden",
    "fallbackChain": "Fallback-Kette",
    "appliesToAll": "Gilt für jede Task. Pro-Task vom Live-Board nach Run-Start überschreiben.",
    "parallelAgents": "Parallele Agents",
    "isolateWorktrees": "In Git-Worktrees isolieren",
    "worktreeOn": "Jede Task läuft im eigenen Worktree, bei Abschluss squash-gemergt.",
    "worktreeOff": "Tasks laufen direkt auf dem aktuellen Branch (keine Isolation).",
    "goalPrompt": "Was willst du bauen?",
    "goalPlaceholder": "z. B. OAuth-Login (Google + GitHub) mit Session-Management hinzufügen",
    "startingInterview": "Interview startet…",
    "startInterview": "Interview starten",
    "introBody": "Ein isolierter Agent interviewt dich, um eine Spec zu bauen, zerlegt sie in einen abhängigkeitsgeordneten Task-Graphen, dann führt eine echte Multi-Agenten-Fleet ihn aus — live auf dem Board schauen.",
    "taskGraphSummary": "Task-Graph · {{count}} Tasks, abhängigkeitsgeordnet",
    "dragToExplore": "ziehen zum Erkunden",
    "show": "zeigen",
    "goalLabel": "Ziel",
    "implementationPlan": "Implementationsplan",
    "approveSpec": "Spec genehmigen → Implementation planen",
    "approveTasks": "Tasks genehmigen",
    "approvePlan": "Plan genehmigen",
    "answerPlaceholder": "Frage beantworten…",
    "changePlaceholder": "Änderung anfordern…"
  },
  "fileExplorer": {
    "emptyDir": "leer",
    "loadFailed": "Dateien konnten nicht geladen werden: {{error}}",
    "expandAllTitle": "Alle Verzeichnisse aufklappen",
    "expandAll": "Alle aufklappen",
    "collapseAllTitle": "Alle Verzeichnisse zuklappen",
    "collapse": "Zuklappen",
    "folders_one": "{{count}} Ordner",
    "folders_other": "{{count}} Ordner",
    "currentDirTitle": "Aktuelles Verzeichnis: {{path}}",
    "navigateToTitle": "Nach {{path}} navigieren",
    "filesSuffix_one": "{{count}} Datei",
    "filesSuffix_other": "{{count}} Dateien",
    "goToDir": "zum Ordner",
    "navigateParentTitle": "Zum übergeordneten Ordner von {{path}} navigieren",
    "parentDirectory": "übergeordneter Ordner",
    "noFiles": "Keine Dateien gefunden",
    "copyAbsPath": "Absoluten Pfad kopieren",
    "copyRelPath": "Relativen Pfad kopieren",
    "openInTerminal": "Im Terminal öffnen",
    "openInFileManager": "Im Dateimanager öffnen",
    "mentionInChat": "Im Chat erwähnen",
    "copyPath": "Pfad kopieren"
  },
  "codeEditor": {
    "sendSelectionAction": "Auswahl an Chat senden",
    "noFilesOpen": "Keine Dateien offen",
    "selectToEdit": "Wähle eine Datei aus dem Explorer zum Bearbeiten",
    "sendSelectedTitle": "Ausgewählte Zeilen an Chat senden",
    "mentionFileTitle": "Diese Datei im Chat erwähnen",
    "sendToChat": "An Chat senden",
    "mentionFile": "Datei erwähnen",
    "loadingEditor": "Editor wird geladen…",
    "selectTab": "Wähle einen Tab um den Inhalt zu sehen"
  },
  "analytics": {
    "loading": "Analytics werden geladen…",
    "heading": "Analytics-Dashboard",
    "autoRefresh": "Auto-Aktualisierung alle 10 s",
    "liveSessions": "Live-Sessions",
    "agents": "Agents",
    "agentsActive": "{{count}} aktiv",
    "totalEvents": "Ereignisse gesamt",
    "categoriesSub": "{{count}} Kategorien",
    "toolCalls": "Tool-Aufrufe",
    "iterationsSub": "{{count}} Iterationen",
    "sessionCost": "Session-Kosten",
    "tokensSub": "{{input}} rein / {{output}} raus",
    "sessionDuration": "Session-Dauer",
    "messagesSub": "{{count}} Nachrichten",
    "eventsByCategory": "Ereignisse nach Kategorie",
    "noEvents": "Noch keine Ereignisse aufgezeichnet.",
    "topEvents": "Top-Ereignisse",
    "activeSessionUsage": "Aktive Session-Nutzung",
    "provider": "Anbieter",
    "model": "Modell",
    "inputTokens": "Eingabe-Token",
    "outputTokens": "Ausgabe-Token",
    "cacheRatio": "Cache-Verhältnis",
    "filesRead": "Gelesene Dateien",
    "noSession": "Keine aktive Session oder warte auf Daten…",
    "healthErrors": "Health & Fehler",
    "errorEvents": "Fehler-Ereignisse",
    "warningEvents": "Warn-Ereignisse",
    "cacheHitRate": "Cache-Trefferquote",
    "totalCategories": "Kategorien gesamt",
    "waitingData": "Warte auf Daten…",
    "recentEvents": "Letzte Ereignisse",
    "noRecentEvents": "Keine aktuellen Ereignisse. Interagiere mit der UI um Ereignisse zu erzeugen."
  },
  "promptLib": {
    "searchPlaceholder": "Prompts suchen…",
    "newPrompt": "＋ Neues Prompt",
    "all": "Alle",
    "recent": "◷ Zuletzt",
    "favorites": "★ Favoriten",
    "noMatch": "Keine passenden Prompts.",
    "newPromptHeading": "Neues Prompt",
    "titlePlaceholder": "Titel *",
    "descPlaceholder": "Einzeilige Beschreibung",
    "categoryPlaceholder": "Kategorie",
    "tagsPlaceholder": "tags, kommasepariert",
    "contentPlaceholder": "Prompt-Inhalt * — {{name}} für Variablen",
    "variables": "Variablen",
    "addVar": "＋ Var",
    "varNamePlaceholder": "Name",
    "varDescPlaceholder": "Beschreibung",
    "removeVarTitle": "Variable entfernen",
    "required": "erforderlich",
    "multiline": "mehrzeilig",
    "enumPlaceholder": "enum: a, b, c",
    "savePrompt": "Prompt speichern",
    "saveFailed": "Prompt konnte nicht gespeichert werden.",
    "titleContentRequired": "Titel und Inhalt sind erforderlich.",
    "toggleFavoriteTitle": "Favorit umschalten",
    "selectOption": "— wählen —",
    "fillMissing": "Ausfüllen: {{missing}}",
    "insertIntoChat": "In Chat einfügen",
    "selectPromptHint": "Prompt zum Vorschauen und Einfügen wählen."
  },
  "skillDetail": {
    "scopeProject": "Projekt",
    "scopeGlobal": "Global",
    "scopeBundled": "Gebündelt",
    "timeoutError": "Zeitüberschreitung der Anfrage. Bitte erneut versuchen.",
    "updateFailed": "Update fehlgeschlagen",
    "saveFailed": "Speichern fehlgeschlagen",
    "uninstallFailed": "Deinstallation fehlgeschlagen",
    "noSkillSelected": "Kein Skill gewählt",
    "selectSkillHint": "Wähle einen Skill aus der Sidebar um die Doku zu sehen",
    "goToChat": "Zum Chat",
    "openSourceRepo": "Quell-Repo öffnen",
    "copySourceUrl": "Quell-URL kopieren",
    "updatedLabel": "↑ Aktualisiert: {{list}}",
    "upToDateLabel": "— Aktuell: {{list}}",
    "errorsLabel": "✗ {{list}}",
    "checkUpdatesTitle": "Auf Updates prüfen",
    "exportTitle": "Skill als .md exportieren",
    "editTitle": "Skill bearbeiten",
    "uninstallTitle": "Skill deinstallieren",
    "closeTitle": "Schließen und zum Chat",
    "backTitle": "Zurück",
    "forwardTitle": "Vor",
    "relatedFiles": "Verwandte Dateien",
    "references": "Referenzen",
    "goToSkillTitle": "Zu {{name}}",
    "loadingContent": "Skill-Inhalt wird geladen…",
    "editingLabel": "Bearbeite {{name}}",
    "editStats": "{{lines}} Zeilen · {{words}} Wörter · {{chars}} Zeichen",
    "charsWarningFmt": "⚠ {{used}} MB / {{limit}} MB",
    "draftSaved": "Entwurf gespeichert",
    "draftRestored": "Entwurf wiederhergestellt",
    "discardDraft": "Entwurf verwerfen",
    "splitViewTitle": "Geteilte Ansicht",
    "hidePreviewTitle": "Vorschau verbergen",
    "contentPlaceholder": "Skill-Inhalt (Markdown)...",
    "loadFailed": "Skill-Inhalt konnte nicht geladen werden",
    "noContent": "Kein Skill-Inhalt verfügbar",
    "uninstallSkillHeading": "Skill deinstallieren",
    "uninstallConfirm": "{{name}} deinstallieren?",
    "uninstallRemovePath": "Dies entfernt den Skill aus {{path}} und kann nicht rückgängig gemacht werden.",
    "uninstallAction": "Deinstallieren"
  },
  "office": {
    "sessionStats": "Session-Stats",
    "clients": "Clients",
    "input": "Eingabe",
    "output": "Ausgabe",
    "cost": "Kosten",
    "agentsSuffix": "Agents",
    "upPrefix": "seit {{time}}",
    "webuiClient": "WebUI-Client",
    "disconnected": "Getrennt",
    "connected": "Verbunden",
    "tuiClient": "TUI-Client",
    "terminal": "Terminal",
    "repl": "REPL",
    "coordinator": "KOORDINATOR",
    "fleetSummary": "Fleet-Zusammenfassung",
    "toolCallsLabel": "Tool-Aufrufe",
    "tokensLabel": "Token",
    "coordinatingFleet": "Koordiniert Fleet",
    "donePrefix": "✓ fertig ·",
    "failedPrefix": "✕ fehlgeschlagen ·",
    "seenPrefix": "vor {{time}} gesehen",
    "availableDesk": "Freier Schreibtisch",
    "mailboxHub": "Postfach-Zentrale",
    "unreadSuffix_one": "{{count}} ungelesen",
    "unreadSuffix_other": "{{count}} ungelesen",
    "allClear": "Alles erledigt",
    "total": "Gesamt",
    "unreadLabel": "Ungelesen",
    "liveActivity": "Live-Aktivität",
    "waitingActivity": "Warte auf Aktivität…",
    "now": "jetzt",
    "fleetHq": "WrongStack Fleet-Zentrale",
    "live": "LIVE",
    "legendStatus": "Status",
    "legendActive": "Aktiv",
    "legendIdle": "Idle",
    "legendError": "Fehler",
    "legendConnections": "Verbindungen",
    "legendMail": "Mail",
    "legendTask": "Task",
    "legendStatusConn": "Status",
    "arrange": "Anordnen",
    "arrangeTitle": "Knoten zurück zum Grundriss",
    "feed": "Feed",
    "feedTitle": "Live-Aktivitäts-Feed umschalten",
    "broadcast": "Broadcast",
    "broadcastTitle": "Nachricht an jede Live-Session im Projekt",
    "broadcastToAll": "An alle Sessions broadcasten",
    "broadcastPlaceholder": "Nachricht an jeden Live-Agent im Projekt…",
    "broadcastSendHint": "⌘/Ctrl+Enter zum Senden",
    "openFullView": "Vollständige Operationsansicht öffnen",
    "rowStatus": "Status",
    "rowModel": "Modell",
    "rowTool": "Tool",
    "rowIterations": "Iterationen",
    "rowToolCalls": "Tool-Aufrufe",
    "rowTokensIn": "Token rein",
    "rowTokensOut": "Token raus",
    "rowTokensTotal": "Token gesamt",
    "rowContext": "Kontext",
    "rowCost": "Kosten",
    "rowLastSeen": "Zuletzt gesehen",
    "rowSurface": "Oberfläche",
    "rowBranch": "Branch",
    "rowPid": "PID",
    "rowDir": "Verz.",
    "rowAgents": "Agents",
    "rowUptime": "Uptime",
    "rowConnections": "Verbindungen",
    "rowTotalMessages": "Nachrichten gesamt",
    "rowUnread": "Ungelesen",
    "recent": "Neueste",
    "noSubject": "(kein Betreff)",
    "fullOperationStream": "Vollständiger Operations-Stream",
    "closeEsc": "Schließen (Esc)",
    "idleDesk": "Freier Platz",
    "fleetHqLabel": "Fleet-Zentrale",
    "clientsSuffix_one": "{{count}} Client",
    "clientsSuffix_other": "{{count}} Clients",
    "taskFallback": "Task",
    "controlLabel": "Steuerung"
  },
  "skillsList": {
    "installTitle": "Skill installieren",
    "createTitle": "Skill erstellen",
    "exportTitle": "Alle Skills als .zip exportieren",
    "checkUpdatesTitle": "Auf Updates prüfen (alle Skills)",
    "searchPlaceholder": "Skills suchen…",
    "loading": "Lädt…",
    "noSkills": "Keine Skills installiert",
    "noMatch": "Keine Skills passen zum Filter",
    "noDescription": "Keine Beschreibung",
    "scopeForeign": "Fremd",
    "installHeading": "Skill Installieren",
    "installHint": "GitHub-Repo-Referenz (owner/repo) oder vollständige URL eingeben.",
    "installPlaceholder": "z. B. wrongstack/skill-name oder https://github.com/owner/repo",
    "installScope": "Installations-Scope:",
    "installBtn": "Installieren",
    "installedMsg": "Installiert: {{names}}",
    "installFailed": "Installation fehlgeschlagen",
    "createHeading": "Skill Erstellen",
    "createHint": "Neuen Skill scaffolding. Erste Zeile ist der Trigger; weitere Zeilen die Beschreibung.",
    "nameLabel": "Name",
    "namePlaceholder": "z. B. mein-neuer-skill",
    "descLabel": "Beschreibung / Trigger",
    "descPlaceholder": "Verwende diesen Skill bei <Trigger-Situation>.\nTrigger: User sagt \"Schlüsselwort\", \"anderes\".",
    "saveIn": "Speichern in:",
    "createBtn": "Skill Erstellen",
    "createdMsg": "Erstellt: {{name}}",
    "createFailed": "Erstellung fehlgeschlagen"
  },
  "timeline": {
    "noEvents": "Noch keine Ereignisse."
  },
  "designStudio": {
    "pickHint": "Kit wählen — der Agent hält sich daran.",
    "gallery": "Galerie",
    "galleryTitle": "Live-Vorschau-Galerie öffnen",
    "stackTitle": "Ziel-Stack",
    "loading": "Kits werden geladen…",
    "notFound": "Keine Design-Kits gefunden.",
    "bestFor": "Am besten für:",
    "light": "Hell",
    "dark": "Dunkel"
  },
  "worktrees": {
    "detached": "(losgelöst)",
    "count_one": "{{count}} Worktree",
    "count_other": "{{count}} Worktrees",
    "baseSuffix": " · Basis {{base}}",
    "baseLabel": "Basis",
    "cleanOrphans": "Verwaiste entfernen",
    "cleanOrphansTitle": "Alle verwaisten Worktrees entfernen",
    "liveBusyTitle": "Ein Lauf ist aktiv — zuerst stoppen",
    "rescanTitle": "Neu scannen",
    "removed_one": "{{count}} Worktree entfernt.",
    "removed_other": "{{count}} Worktrees entfernt.",
    "failed": "Fehlgeschlagen",
    "mergedIntoBase": "{{branch}} in Basis zusammengeführt.",
    "conflictMerge": "Konflikt beim Zusammenführen von {{branch}}: {{files}}",
    "seeGit": "siehe git",
    "mergeFailed": "Zusammenführen fehlgeschlagen: {{reason}}",
    "unknownReason": "unbekannt",
    "mergeConfirmTitle": "{{branch}} in {{base}} zusammenführen?",
    "mergeConfirmMsg": "Squash-merged diesen Branch auf den Basis-Branch. Bricht sauber ab bei Konflikten.",
    "mergeAction": "Zusammenführen",
    "removeConfirmTitle": "{{branch}} entfernen?",
    "removeConfirmMsg": "Entfernt das Worktree-Checkout und löscht seinen Branch. Nicht zusammengeführte Arbeit geht verloren.",
    "empty": "Keine Worktrees.",
    "emptyHint": "SDD-/AutoPhase-Läufe erstellen hier isolierte Worktrees. Verwaiste abgestürzter Läufe erscheinen ebenfalls.",
    "actOpenTerm": "Im Terminal öffnen",
    "actOpenFolder": "Ordner öffnen",
    "actViewChanges": "Änderungen ansehen",
    "actMerge": "In Basis zusammenführen",
    "actRemove": "Entfernen / verwerfen",
    "live": "live",
    "noUncommitted": "Keine ungespeicherten Änderungen",
    "commitsAhead_one": "{{count}} Commit voraus",
    "commitsAhead_other": "{{count}} Commits voraus",
    "more": "…{{count}} mehr"
  },
  "officeSettings": {
    "heading": "Bürokarte",
    "headingHint": "Visualisieren Sie Ihre Flotte als Bürogrundriss mit Live-Agent-Status.",
    "statAgents": "Agenten",
    "statMail": "Post",
    "unreadSuffix": " ungelesen",
    "sectionView": "Ansicht",
    "sectionDisplay": "Anzeige",
    "sectionBackground": "Hintergrund",
    "sectionRecent": "Letzte Aktivität",
    "eventsTrackedSuffix": " Ereignisse verfolgt",
    "recentHint": "Post-Sends, Agent-Spawns und Statusänderungen erscheinen hier.",
    "sectionShortcuts": "Tastenkürzel",
    "sectionLegend": "Legende",
    "hudLabel": "HUD",
    "hudDesc": "Echtzeit-Sitzungsstatistik-Overlay anzeigen",
    "hudToggle": "HUD umschalten",
    "minimapLabel": "Minimap",
    "minimapDesc": "Übersichts-Minimap anzeigen",
    "minimapToggle": "Minimap umschalten",
    "controlsLabel": "Steuerung",
    "controlsDesc": "Zoom- und Fit-Steuerung anzeigen",
    "controlsToggle": "Steuerung umschalten",
    "animateLabel": "Kanten animieren",
    "animateDesc": "Fluss auf aktiven Verbindungen animieren",
    "animateToggle": "Kantenanimation umschalten",
    "legendLabel": "Legende anzeigen",
    "legendDesc": "Status- und Verbindungslegende anzeigen",
    "legendToggle": "Legende umschalten",
    "feedLabel": "Live-Feed",
    "feedDesc": "Unterer Streifen mit letzter prozessübergreifender Aktivität",
    "feedToggle": "Live-Feed umschalten",
    "fitView": "Anpassen",
    "zoomIn": "Vergrößern",
    "zoomOut": "Verkleinern",
    "resetZoom": "Zoom zurücksetzen",
    "legendActive": "Aktiv (läuft)",
    "legendIdle": "Inaktiv",
    "legendError": "Fehler",
    "legendOffline": "Offline",
    "bg": {
      "dots": "Punkte",
      "lines": "Linien",
      "cross": "Kreuz",
      "none": "Keine"
    }
  }
}
